#ifdef USE_MARBLE

vec2 warpUv = mix(
    vPosition.xy,
    vPosition.zx,
    vPosition.z
) * marbleZoom;

diffuseColor.rgb = texture2D(map, domainWarp(warpUv)).rgb;

#endif
